import * as dbConstants from '../../dao/dbConstants'
import * as CompanyDAO from '../../dao/CompanyDAO';
import * as FirmDAO from '../../dao/FirmDAO';
import * as KnowledgeBaseDAO from '../../dao/KnowledgeBaseDAO';
import * as ProductDAO from '../../dao/ProductDAO';
import * as BillingMetricsDAO from '../../dao/BillingMetricDAO';
import * as CampaignDAO from '../../dao/CampaignDAO';
import { getContentStatusFilterOptions } from '../../utils/contentStatusUtils';
import { getFirmAccountTypeFilterOptions } from '../../utils/firmAccountTypeConstants';

import {
  INPUT_TYPE_CHECKBOX, INPUT_TYPE_SELECT_MULTI, INPUT_TYPE_SELECT_SINGLE,
  INPUT_TYPE_TEXT, INPUT_TYPE_TEXT_AREA, INPUT_TYPE_DATE, INPUT_TYPE_DATETIME
} from '../componentConstants';

const assetFilters = [];
const assetOpenSearchFields = ['name', 'description'];

const articleFilters = [];
const articleOpenSearchFields = ['name'];

const brandVoiceFilters = [];
const brandVoiceOpenSearchFields = ['name'];

const campaignsFilters = [
  {
    type: INPUT_TYPE_SELECT_SINGLE, label: 'Company', name: 'Company', dbFieldValue: 'companyId',
    defaultValue: '', isRequired: false, isDisabled: false, optionsFunction: CompanyDAO.getListOptions,
    toolTipText: 'Select a company to filter campaigns'
  }
]
const campaignOpenSearchFields = ['name']

const linkFilters = [];
const linkOpenSearchFields = ['title', 'url', 'description'];
const testimonialFilters = [];
const testimonialOpenSearchFields = ['title', 'username', 'text'];

const companyFilters = [
  {
    type: INPUT_TYPE_SELECT_SINGLE, label: 'Type', name: 'Type', dbFieldValue: 'companyTypeId',
    defaultValue: '', isRequired: false, isDisabled: false, optionsFunction: CompanyDAO.getTypeListOptions,
    includeNoneOption: false, toolTipText: 'Select a type to filter companies'
  },
  {
    type: INPUT_TYPE_SELECT_SINGLE, label: 'Knowledge Base', name: 'KnowledgeBase', dbFieldValue: 'knowledgeBaseIds',
    defaultValue: '', isRequired: false, isDisabled: false, optionsFunction: KnowledgeBaseDAO.getListOptions,
    toolTipText: 'Select a knowledge base to filter companies', dbFieldOperatorType: dbConstants.OPERATOR_IN_ARRAY
  },
];
const companyOpenSearchFields = ['name'];

const contentFilters = [
  {
    type: INPUT_TYPE_SELECT_SINGLE, label: 'Status', name: 'Status', dbFieldValue: 'status',
    defaultValue: '', isRequired: false, isDisabled: false, optionsFunction: getContentStatusFilterOptions,
    includeNoneOption: false, toolTipText: 'Filter content by status', isFixed: true
  },
  {
    type: INPUT_TYPE_SELECT_SINGLE, label: 'Content Type', name: 'ContentType', dbFieldValue: 'contentTypeId',
    defaultValue: '', isRequired: false, isDisabled: false,
    dataValueField: 'contentTypeId', dataLabelField: 'contentTypeName',
    includeNoneOption: false, toolTipText: 'Filter by content type', isFixed: true
  },
  {
    type: INPUT_TYPE_SELECT_SINGLE, label: 'Company', name: 'Company', dbFieldValue: 'companyId',
    defaultValue: '', isRequired: false, isDisabled: false, optionsFunction: CompanyDAO.getListOptions,
    includeNoneOption: false, toolTipText: 'Filter content by company'
  },
  {
    type: INPUT_TYPE_SELECT_SINGLE, label: 'Campaign', name: 'Campaign', dbFieldValue: 'campaignId',
    defaultValue: '', isRequired: false, isDisabled: false, optionsFunction: CampaignDAO.getListOptions,
    includeNoneOption: false, toolTipText: 'Filter content by campaign'
  },
  {
    type: INPUT_TYPE_DATE, label: 'Date From', name: 'DateFrom', dbFieldValue: 'createdOn',
    operator: dbConstants.OPERATOR_GREATERTHAN_EQUAL,
    toolTipText: 'Filter records created on or after this date'
  },
  {
    type: INPUT_TYPE_DATE, label: 'Date To', name: 'DateTo', dbFieldValue: 'createdOn',
    operator: dbConstants.OPERATOR_LESSTHAN_EQUAL,
    toolTipText: 'Filter records created on or before this date'
  }
];
const contentOpenSearchFields = ['title'];

const firmFilters = [
  {
    type: INPUT_TYPE_SELECT_SINGLE, label: 'Status', name: 'Status', dbFieldValue: 'status',
    defaultValue: '', isRequired: false, isDisabled: false, optionsFunction: FirmDAO.getStatusListOptions,
    includeNoneOption: false, style: { maxWidth: '250px' }, toolTipText: 'Select a status to filter firms'
  },
  {
    type: INPUT_TYPE_SELECT_SINGLE, label: 'Firm Type', name: 'AccountType', dbFieldValue: 'accountType',
    defaultValue: '', isRequired: false, isDisabled: false, optionsFunction: getFirmAccountTypeFilterOptions,
    includeNoneOption: false, style: { maxWidth: '250px' }, toolTipText: 'Select a firm type to filter firms'
  }
];

const billingFilters = [
  {
    type: INPUT_TYPE_SELECT_SINGLE, label: 'Firm', name: 'Firm', dbFieldValue: 'firmId',
    defaultValue: '', isRequired: false, isDisabled: false, optionsFunction: BillingMetricsDAO.getFirmNameListOptions,
    includeNoneOption: false, style: { maxWidth: '250px' }, toolTipText: 'Filter by firm'
  },
  {
    type: INPUT_TYPE_SELECT_SINGLE, label: 'User', name: 'User', dbFieldValue: 'userId',
    defaultValue: '', isRequired: false, isDisabled: false,
    optionsFunction: (params) => {
      const firmId = params?.filterValues?.Firm;
      return BillingMetricsDAO.getUserNameListOptions(firmId);
    },
    includeNoneOption: false, style: { maxWidth: '250px' }, toolTipText: 'Filter by user',
    dependsOn: ['Firm'],
    refetchOnSearch: true
  },
  {
    type: INPUT_TYPE_SELECT_SINGLE, label: 'Screen', name: 'Screen', dbFieldValue: 'entityName',
    defaultValue: '', isRequired: false, isDisabled: false, optionsFunction: BillingMetricsDAO.getScreenListOptions,
    includeNoneOption: false, style: { maxWidth: '250px' }, toolTipText: 'Filter by screen'
  },
  {
    type: INPUT_TYPE_SELECT_SINGLE, label: 'Operation', name: 'Operation', dbFieldValue: 'screenName',
    defaultValue: '', isRequired: false, isDisabled: false, optionsFunction: BillingMetricsDAO.getOperationListOptions,
    includeNoneOption: false, style: { maxWidth: '250px' }, toolTipText: 'Filter by operation type'
  },
  {
    type: INPUT_TYPE_DATE, label: 'Created From', name: 'CreatedFrom', dbFieldValue: 'createdOn',
    operator: dbConstants.OPERATOR_GREATERTHAN_EQUAL,
    style: { maxWidth: '250px' }, toolTipText: 'Filter records created on or after this date'
  },
  {
    type: INPUT_TYPE_DATE, label: 'Created To', name: 'CreatedTo', dbFieldValue: 'createdOn',
    operator: dbConstants.OPERATOR_LESSTHAN_EQUAL,
    style: { maxWidth: '250px' }, toolTipText: 'Filter records created on or before this date'
  }
];

const firmOpenSearchFields = ['name', 'primaryUserName', 'primaryUserEmail'];
const knowledgeBaseFilters = [];
const knowledgeBaseOpenSearchFields = ['name'];

const personaFilters = [];
const personaOpenSearchFields = ['name'];

const productFilters = [
  {
    type: INPUT_TYPE_SELECT_SINGLE, label: 'Company', name: 'Company', dbFieldValue: 'companyId',
    defaultValue: '', isRequired: false, isDisabled: false, optionsFunction: CompanyDAO.getListOptions,
    includeNoneOption: false, style: { maxWidth: '250px' }, toolTipText: 'Select a company to filter products'
  },
  {
    type: INPUT_TYPE_SELECT_SINGLE, label: 'Type', name: 'Type', dbFieldValue: 'productTypeId',
    defaultValue: '', isRequired: false, isDisabled: false, optionsFunction: ProductDAO.getAllTypeListOptions,
    includeNoneOption: false, style: { maxWidth: '200px' }, toolTipText: 'Select a type to filter products'
  },
];

const productOpenSearchFields = ['name'];

const sourceContentFilters = [
  {
    type: INPUT_TYPE_SELECT_SINGLE, label: 'Company', name: 'Company', dbFieldValue: 'companyId',
    defaultValue: '', isRequired: false, isDisabled: false, optionsFunction: CompanyDAO.getListOptions,
    includeNoneOption: false, style: { maxWidth: '250px' }, toolTipText: 'Select a company to filter source contents'
  }
];
const sourceContentOpenSearchFields = ['name'];

const userOpenSearchFields = ['firstName', 'lastName', 'email']

const writingStyleFilters = []
const writingStyleOpenSearchFields = ['name'];

const roleFilters = [];
const roleOpenSearchFields = ['name'];

const promptTemplateFilters = [
  {
    type: INPUT_TYPE_TEXT, label: 'Category', name: 'Category', dbFieldValue: 'category',
    defaultValue: '', isRequired: false, isDisabled: false, includeNoneOption: false,
    style: { maxWidth: '200px' }, toolTipText: 'Filter by logical category (e.g. content, campaign)',
  },
  {
    type: INPUT_TYPE_TEXT, label: 'Type', name: 'Type', dbFieldValue: 'type',
    defaultValue: '', isRequired: false, isDisabled: false, includeNoneOption: false,
    style: { maxWidth: '200px' }, toolTipText: 'Filter by prompt type (system, user, assistant, etc.)',
  },
  {
    type: INPUT_TYPE_TEXT, label: 'Intent', name: 'Intent', dbFieldValue: 'intent',
    defaultValue: '', isRequired: false, isDisabled: false, includeNoneOption: false,
    style: { maxWidth: '200px' }, toolTipText: 'Filter by intent this prompt variant applies to',
  },
];
const promptTemplateOpenSearchFields = ['name'];

const instructionBlockScopeOptions = async () => [
  { value: 'common', label: 'Common' },
  { value: 'vertical', label: 'Vertical' },
  { value: 'intent', label: 'Intent' },
];

const instructionBlockFilters = [
  {
    type: INPUT_TYPE_SELECT_SINGLE, label: 'Scope', name: 'Scope', dbFieldValue: 'scope',
    defaultValue: '', isRequired: false, isDisabled: false, includeNoneOption: true,
    optionsFunction: instructionBlockScopeOptions,
    style: { maxWidth: '200px' }, toolTipText: 'Filter by block scope (common, vertical, intent)',
  },
  {
    type: INPUT_TYPE_TEXT, label: 'Content Type', name: 'ContentType', dbFieldValue: 'contentTypeKey',
    defaultValue: '', isRequired: false, isDisabled: false, includeNoneOption: false,
    style: { maxWidth: '200px' }, toolTipText: 'Filter by content type key (e.g. content_blog)',
  },
];
const instructionBlockOpenSearchFields = ['name'];

const supportRequestStatusOptions = async () => [
  { value: 'pending', label: 'Pending' },
  { value: 'in_progress', label: 'In Progress' },
  { value: 'resolved', label: 'Resolved' },
  { value: 'closed', label: 'Closed' },
];

const supportRequestTriggerTypeOptions = async () => [
  { value: 'confidence_based', label: 'Low Confidence' },
  { value: 'user_requested', label: 'User Requested' },
];

const supportRequestFilters = [
  {
    type: INPUT_TYPE_SELECT_SINGLE, label: 'Status', name: 'Status', dbFieldValue: 'status',
    defaultValue: '', isRequired: false, isDisabled: false, optionsFunction: supportRequestStatusOptions,
    includeNoneOption: false, style: { maxWidth: '200px' }, toolTipText: 'Filter by request status'
  },
  {
    type: INPUT_TYPE_SELECT_SINGLE, label: 'Type', name: 'TriggerType', dbFieldValue: 'triggerType',
    defaultValue: '', isRequired: false, isDisabled: false, optionsFunction: supportRequestTriggerTypeOptions,
    includeNoneOption: false, style: { maxWidth: '200px' }, toolTipText: 'Filter by trigger type'
  },
];
const supportRequestOpenSearchFields = ['userName', 'userEmail', 'triggerQuestion'];

// Both screens pass showSearch, so without an entry here their search box
// narrows nothing: getSearchQueryCriteriaObject returns null and the query is
// dropped. A field named here must be one the entity's DAO constants allow as
// a criterion, or the backend rejects the search — which is why the validators
// are searched by name alone and not also by description.
const backofficeUserOpenSearchFields = ['firstName', 'lastName', 'email'];
const contentValidatorOpenSearchFields = ['name'];


const allFilters = {
  [dbConstants.ENTITY_NAME_ASSET]: assetFilters,
  [dbConstants.ENTITY_NAME_ARTICLE]: articleFilters,
  [dbConstants.ENTITY_NAME_BRAND_VOICE]: brandVoiceFilters,
  [dbConstants.ENTITY_NAME_CAMPAIGN]: campaignsFilters,
  [dbConstants.ENTITY_NAME_COMPANY]: companyFilters,
  [dbConstants.ENTITY_NAME_CONTENT]: contentFilters,
  [dbConstants.ENTITY_NAME_BACK_OFFICE_FIRM]: firmFilters,
  [dbConstants.ENTITY_NAME_BACK_OFFICE_BILLING_METRICS]: billingFilters,
  [dbConstants.ENTITY_NAME_BACK_OFFICE_SUPPORT_REQUEST]: supportRequestFilters,
  [dbConstants.ENTITY_NAME_KNOWLEDGE_BASE]: knowledgeBaseFilters,
  [dbConstants.ENTITY_NAME_PERSONA]: personaFilters,
  [dbConstants.ENTITY_NAME_PRODUCT]: productFilters,
  [dbConstants.ENTITY_NAME_ROLE]: roleFilters,
  [dbConstants.ENTITY_NAME_SOURCE_CONTENT]: sourceContentFilters,
  [dbConstants.ENTITY_NAME_WRITING_STYLE]: writingStyleFilters,
  [dbConstants.ENTITY_NAME_BACK_OFFICE_PROMPT_TEMPLATE]: promptTemplateFilters,
  [dbConstants.ENTITY_NAME_BACK_OFFICE_INSTRUCTION_BLOCK]: instructionBlockFilters,
  [dbConstants.ENTITY_NAME_LINK]: linkFilters,
  [dbConstants.ENTITY_NAME_TESTIMONIAL]: testimonialFilters,
};

const allOpenSearchFields = {
  [dbConstants.ENTITY_NAME_ASSET]: assetOpenSearchFields,
  [dbConstants.ENTITY_NAME_ARTICLE]: articleOpenSearchFields,
  [dbConstants.ENTITY_NAME_BRAND_VOICE]: brandVoiceOpenSearchFields,
  [dbConstants.ENTITY_NAME_CAMPAIGN]: campaignOpenSearchFields,
  [dbConstants.ENTITY_NAME_COMPANY]: companyOpenSearchFields,
  [dbConstants.ENTITY_NAME_CONTENT]: contentOpenSearchFields,
  [dbConstants.ENTITY_NAME_BACK_OFFICE_FIRM]: firmOpenSearchFields,
  [dbConstants.ENTITY_NAME_BACK_OFFICE_SUPPORT_REQUEST]: supportRequestOpenSearchFields,
  [dbConstants.ENTITY_NAME_BACK_OFFICE_USER]: backofficeUserOpenSearchFields,
  [dbConstants.ENTITY_NAME_BACK_OFFICE_CONTENT_VALIDATOR]: contentValidatorOpenSearchFields,
  [dbConstants.ENTITY_NAME_KNOWLEDGE_BASE]: knowledgeBaseOpenSearchFields,
  [dbConstants.ENTITY_NAME_PERSONA]: personaOpenSearchFields,
  [dbConstants.ENTITY_NAME_PRODUCT]: productOpenSearchFields,
  [dbConstants.ENTITY_NAME_ROLE]: roleOpenSearchFields,
  [dbConstants.ENTITY_NAME_SOURCE_CONTENT]: sourceContentOpenSearchFields,
  [dbConstants.ENTITY_NAME_USER]: userOpenSearchFields,
  [dbConstants.ENTITY_NAME_WRITING_STYLE]: writingStyleOpenSearchFields,
  [dbConstants.ENTITY_NAME_BACK_OFFICE_PROMPT_TEMPLATE]: promptTemplateOpenSearchFields,
  [dbConstants.ENTITY_NAME_BACK_OFFICE_INSTRUCTION_BLOCK]: instructionBlockOpenSearchFields,
  [dbConstants.ENTITY_NAME_LINK]: linkOpenSearchFields,
  [dbConstants.ENTITY_NAME_TESTIMONIAL]: testimonialOpenSearchFields,
};

export const getFilters = (entityName) => {
  return allFilters[entityName];
};

const getSelectListFilterCriteria = (filter, value) => {
  if (!value || (Array.isArray(value) && value.length === 0)) {
    return null;
  }
  if (value === '-1') {
    const criteria = [
      {
        fieldName: filter.dbFieldValue,
        operator: dbConstants.OPERATOR_NULL,
        value,
      },
    ];
    if (filter.dbFieldOperatorType === dbConstants.OPERATOR_IN_ARRAY) {
      criteria.push({ fieldName: filter.dbFieldValue, operator: dbConstants.OPERATOR_EQUAL, value: '{}' });
    }
    return {
      operator: dbConstants.OPERATOR_OR,
      criteria: criteria,
    };
  }

  return {
    operator: dbConstants.OPERATOR_AND,
    criteria: [
      {
        fieldName: filter.dbFieldValue,
        operator:
          Array.isArray(value)
            ? dbConstants.OPERATOR_IN
            : filter.dbFieldOperatorType === dbConstants.OPERATOR_IN_ARRAY
              ? dbConstants.OPERATOR_IN_ARRAY
              : dbConstants.OPERATOR_EQUAL,
        value: value,
      },
    ],
  };
};

const getDateFilterCriteria = (filter, value) => {
  let adjustedValue = value;
  if (filter.operator === dbConstants.OPERATOR_LESSTHAN_EQUAL) {
    const date = new Date(value);
    date.setHours(23, 59, 59, 999);
    adjustedValue = date.toISOString();
  }

  return {
    operator: dbConstants.OPERATOR_AND,
    criteria: [
      {
        fieldName: filter.dbFieldValue,
        operator: filter.operator,
        value: adjustedValue,
      },
    ],
  };
};

const getSingleSelectFilterCriteria = (filter, value) => {
  return getSelectListFilterCriteria(filter, value)
}

const getMultiSelectFilterCriteria = (filter, value) => {
  return getSelectListFilterCriteria(filter, value)
}

const getTextFilterCriteria = (filter, value) => {
  return {
    operator: dbConstants.OPERATOR_AND
    , criteria: [
      {
        fieldName: filter.dbFieldValue,
        operator: dbConstants.OPERATOR_LIKE_CASEINSENSITIVE,
        value: value
      }
    ]
  };
}

const getCheckboxFilterCriteria = (filter, value) => {
  return {
    operator: dbConstants.OPERATOR_AND
    , criteria: [
      {
        fieldName: filter.dbFieldValue,
        operator: (Array.isArray(value) ? dbConstants.OPERATOR_IN : dbConstants.OPERATOR_EQUAL),
        value: value
      }
    ]
  };
}

const getBasicCriteria = (fieldName, value) => {
  return {
    operator: dbConstants.OPERATOR_AND
    , criteria: [
      {
        fieldName: fieldName,
        operator: (Array.isArray(value) ? dbConstants.OPERATOR_IN : dbConstants.OPERATOR_EQUAL),
        value: value
      }
    ]
  };
}


const getFilterCriteria = (filter, value) => {
  if (!filter?.type || !filter?.dbFieldValue || !value) {
    return null;
  }

  switch (filter.type) {
    case INPUT_TYPE_SELECT_SINGLE:
      return getSingleSelectFilterCriteria(filter, value);
    case INPUT_TYPE_SELECT_MULTI:
      return getMultiSelectFilterCriteria(filter, value);
    case INPUT_TYPE_TEXT:
    case INPUT_TYPE_TEXT_AREA:
      return getTextFilterCriteria(filter, value);
    case INPUT_TYPE_CHECKBOX:
      return getCheckboxFilterCriteria(filter, value);
    case INPUT_TYPE_DATE:
    case INPUT_TYPE_DATETIME:
      return getDateFilterCriteria(filter, value);
    default:
      return null;
  }
};

const getSearchQueryCriteriaObject = (entityName, searchQuery) => {
  if(!searchQuery) {
    return null;
  }
  const fieldNames = allOpenSearchFields[entityName]
  if(!Array.isArray(fieldNames) || !fieldNames?.length) {
    return null;
  }

  let criteria = fieldNames.map(fieldName => {
    return {
      fieldName: fieldName,
      operator: dbConstants.OPERATOR_LIKE_CASEINSENSITIVE,
      value: searchQuery
    }
  })

  return { operator: dbConstants.OPERATOR_OR, criteria: criteria};
};

export const getFiltersCriteria = (entityName, searchQuery, filters, filterValues, additionalCriteria) => {
  console.log('getFiltersCriteria - entityName:', entityName, ', searchQuery:', searchQuery, ', filters:', filters, ', filterValues:', filterValues);
  let groups = [];
  if (Array.isArray(filters) && !!filters?.length) {
    filters.forEach((filter) => {
      const criteria = getFilterCriteria(filter, filterValues[filter.name]);
      if (!!criteria) {
        groups.push(criteria);
      }
    });
  }
  const searchQueryGroup = getSearchQueryCriteriaObject(entityName, searchQuery);
  if (!!searchQueryGroup) {
    groups.push(searchQueryGroup);
  }

  if (!!additionalCriteria && typeof additionalCriteria === 'object' && Object.keys(additionalCriteria).length) {
    Object.keys(additionalCriteria).forEach((key) => groups.push(getBasicCriteria(key, additionalCriteria[key])));
  }

  if (groups.length < 1) {
    return null;
  }

  let criteriaObj = {
    operator: dbConstants.OPERATOR_AND,
    groups: groups,
  };
  console.log('criteriaGroupObj: ', criteriaObj);
  return criteriaObj;
};